<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/messages/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ویرایش پیام</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-text-field color="black" v-model="message.title" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-checkbox
                label="پیام فایل ضمیمه دارد؟"
                v-model="has_attachment"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="2">
            <vue-persian-datetime-picker color="black" v-model="message.expire_at"
                                         type="datetime"
                                         custom-input="#expire_at"
                                         auto-submit></vue-persian-datetime-picker>
            <v-text-field label="تاریخ و زمان انقضا پیام" v-model="message.expire_at" id="expire_at"
                          color="black">
            </v-text-field>
          </v-col>
          <v-col v-if="has_attachment" cols="2">
            <v-select
                label="نوع فایل پیام را مشخص کنید"
                :items="attachment_types"
                v-model="message.attachment_type"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="4" v-if="has_attachment">
            <v-text-field label="فایل"
                          @click="fileDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="message.url"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea color="black" v-model="message.content" label="محتوای پیام"></v-textarea>
          </v-col>

          <v-col cols="12" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="update()">ویرایش</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="fileDialog" max-width="50vw">
      <drag-and-drop module="item" ref="image-uploader" @closeUploadFileDialog="fileDialog = false"
                     @changeFile="message.url = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "MessageEdit",
  components: {DragAndDrop, VuePersianDatetimePicker},
  data() {
    return {
      fileDialog: false,
      has_attachment: null,
      attachment_types: [
        {value: 'audio', text: 'فایل صوتی'},
        {value: 'video', text: 'ویدیو'},
        {value: 'pdf', text: 'پی دی اف'},
        {value: 'image', text: 'تصویر'},
        {value: 'zip', text: 'فایل فشرده'},
      ],
      message: {
        title: null,
        content: null,
        instructor_ids: null,
        student_ids: null,
        expire_at: null,
        url: null,
        attachment_type: null,
      }
    }
  },
  mounted() {
    this.getMessage()
  },
  methods: {
    getMessage() {
      window.axios.get('message/crud/get/' + this.$route.params.id).then((res) => {
        this.message = res.data.data
        if (this.message.url) {
          this.has_attachment = true
        } else {
          this.has_attachment = false
        }
        this.message.expire_at = res.data.data.expire_at_fa
      })
    },
    update() {
      window.axios.post('message/crud/update/' + this.$route.params.id, this.message).then(() => {
        this.openSnackbar("پیام مورد نظر با موفقیت ویرایش شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
  }
}
</script>

<style scoped>

</style>